import React from "react";

export default function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-white/60 py-14 text-center">
      {Icon && <Icon size={28} className="mb-3 text-navy/20" />}
      <p className="text-sm font-semibold uppercase tracking-wide text-navy/40">{title}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}
